import { Controller } from "@hotwired/stimulus";

// Manages row selection and summary for bulk plan mapping. Connects to data-controller="bulk-plan-selection"
export default class extends Controller {
  static targets = ["rowCheckbox", "selectionSummary", "applyButton", "selectedCount", "selectedMemberCount", "bulkForm", "targetPlanSelect"];

  connect() {
    this.updateSummary();
  }

  selectAll() {
    this.rowCheckboxTargets.forEach((cb) => { cb.checked = true; });
    this.updateSummary();
  }

  clearSelection() {
    this.rowCheckboxTargets.forEach((cb) => { cb.checked = false; });
    this.updateSummary();
  }

  selectPendingOnly() {
    this.rowCheckboxTargets.forEach((cb) => {
      cb.checked = cb.dataset.status === "pending";
    });
    this.updateSummary();
  }

  selectUnresolvedOnly() {
    this.selectPendingOnly();
  }

  selectSkippedOnly() {
    this.rowCheckboxTargets.forEach((cb) => {
      cb.checked = cb.dataset.status === "skipped";
    });
    this.updateSummary();
  }

  toggleRow(event) {
    const id = event.currentTarget.dataset.rowCheckboxId;
    if (!id) return;
    const cb = document.getElementById(id);
    if (cb) {
      cb.checked = !cb.checked;
      cb.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  updateSummary() {
    const checked = this.rowCheckboxTargets.filter((cb) => cb.checked);
    const count = checked.length;
    const memberCount = checked.reduce((sum, cb) => sum + parseInt(cb.dataset.memberCount || "0", 10), 0);

    this.rowCheckboxTargets.forEach((cb) => {
      const row = cb.closest("tr.bulk-map-row") || cb.closest("tr");
      if (row) {
        if (cb.checked) {
          row.classList.add("bulk-map-row--selected");
          row.classList.remove("hover:bg-gray-100");
        } else {
          row.classList.remove("bulk-map-row--selected");
          row.classList.add("hover:bg-gray-100");
        }
      }
    });

    if (this.hasSelectionSummaryTarget) {
      this.selectionSummaryTarget.dataset.selectedCount = count;
      this.selectionSummaryTarget.dataset.selectedMemberCount = memberCount;
    }
    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = count;
    }
    if (this.hasSelectedMemberCountTarget) {
      this.selectedMemberCountTarget.textContent = memberCount;
    }
    if (this.hasApplyButtonTarget) {
      this.applyButtonTarget.disabled = count === 0;
      const label = this.applyButtonTarget.dataset.labelTemplate;
      if (label) {
        this.applyButtonTarget.textContent = label.replace("{count}", count);
      }
    }
  }

  confirmAndSubmit(event) {
    event.preventDefault();
    const checked = this.rowCheckboxTargets.filter((cb) => cb.checked);
    if (checked.length === 0) return;

    const memberCount = checked.reduce((sum, cb) => sum + parseInt(cb.dataset.memberCount || "0", 10), 0);
    const sampleStrings = checked.slice(0, 5).map((cb) => cb.dataset.sourceString || "(unknown)").join("\n- ");
    const targetSelect = this.hasTargetPlanSelectTarget ? this.targetPlanSelectTarget : this.element.querySelector('select[name="target_plan_id"]');
    const targetPlanName = targetSelect?.selectedOptions[0]?.text || targetSelect?.options[targetSelect.selectedIndex]?.text || "—";

    let msg = `You are about to map:\n\n`;
    msg += `• ${checked.length} selected source plan string${checked.length === 1 ? "" : "s"}\n`;
    msg += `• ${memberCount} imported member record${memberCount === 1 ? "" : "s"}\n\n`;
    msg += `Target plan: ${targetPlanName}\n\n`;
    msg += `Sample selected source strings:\n- ${sampleStrings}`;

    if (this.confirmed(msg)) {
      this.bulkFormTarget.requestSubmit();
    }
  }

  confirmed(msg) {
    return confirm(msg);
  }
}
